import { Context } from '@nuxt/types'
import { stringify } from 'query-string'

export default function (context: Context) {
  context.$axios.setHeader('Accept', 'application/json,text/plain;q=0.9,*/*;q=0.8')

  context.$axios.defaults.paramsSerializer = params => stringify(params, { arrayFormat: 'comma', encode: false, skipEmptyString: true })
}
